import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";

import { Company } from "../models/company.model";

import * as fromCompanyAction from "./../actions/company.action";

export interface State extends EntityState<Company> {
  selectedCompanyCode: string | null;
}

export const adapter: EntityAdapter<Company> = createEntityAdapter<Company>({
  selectId: (company: Company) => company.companyCode,
  sortComparer: false,
});

const initialState: State = adapter.getInitialState({
  selectedCompanyCode: null,
});

export function reducer(state = initialState, action: fromCompanyAction.Actions): State {
  switch (action.type) {
    case fromCompanyAction.ActionTypes.ADD_COMPANY: {
      return adapter.addOne(action.payload, state);
    }
    case fromCompanyAction.ActionTypes.FETCH_COMPANIES: {
      return state;
    }
    case fromCompanyAction.ActionTypes.FETCH_COMPANIES_SUCCESS: {
      return adapter.addMany(action.payload, adapter.removeAll(state));
    }
    case fromCompanyAction.ActionTypes.SELECT_COMPANY: {
      return { ...state, selectedCompanyCode: action.payload };
    }
    case fromCompanyAction.ActionTypes.SELECT_COMPANY_V2: {
      return { ...state, selectedCompanyCode: action.payload };
    }
    case fromCompanyAction.ActionTypes.CLEAR_COMPANIES: {
      return adapter.removeAll(state);
    }
    default: {
      return state;
    }
  }
}

export const getSelectedCompanyCode = (state: State) => state && state.selectedCompanyCode;

export const getCompaniesEntities = (state: State) => state && state.entities;

export const getCompaniesArray = (state: State) => {
  const companiesArray = Object.keys(state?.entities || {});
  if (companiesArray.length > 0) {
    const companies: Company[] = companiesArray.map((i) => state.entities[i]);
    return companies;
  } else {
    return [];
  }
};
